import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    exhibitionData: null,
    language: 'zh-Hant'
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_EXHIBITION_DATA(state, data) {
      state.exhibitionData = data
    },
    SET_LANGUAGE(state, lang) {
      state.language = lang
    }
  },
  actions: {
    setLoading({ commit }, value) {
      commit('SET_LOADING', value)
    },
    setExhibitionData({ commit }, data) {
      commit('SET_EXHIBITION_DATA', data)
    },
    setLanguage({ commit }, lang) {
      commit('SET_LANGUAGE', lang)
    }
  },
  getters: {
    isLoading: state => state.loading,
    exhibitionData: state => state.exhibitionData,
    currentLanguage: state => state.language
  }
})